<template>
  <div class="role-box" :class="[zsTjTheme]">
    <div class="header">
      <div class="left">
        <img class="icon" :src="dataSource.attr1.icon.value" alt="" />
        <span class="text">{{ dataSource.name.value }}</span>
        <span class="text">
          {{ levelInfo }}
        </span>
      </div>
      <div class="right">
        <div v-if="resetVisible" class="btn" @click="handleReset">
          {{ $t("tj.zs.hydjsj") }}
        </div>
      </div>
    </div>
    <div v-if="starInfo" class="star-box">
      <img
        :src="
          zsTjTheme == 'light'
            ? require('@/assets/zs_imgs/light-star-icon.png')
            : require('@/assets/zs_imgs/star-icon.png')
        "
        v-for="i in starInfo"
        :key="i"
      />
    </div>
    <div :class="['role-img-box']">
      <img :class="['role-img', { 'top-role': dataSource.name.value === '神圣悠丝缇亚' }]" :src="roleUrl" alt="" />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  props: {
    dataSource: {
      type: Object,
      default: () => ({})
    },
    styleInfo: {
      type: Object,
      default: () => ({})
    },
    resetVisible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["zsTjTheme"]),
    starInfo() {
      return (
        (this.dataSource.stars &&
          this.dataSource.stars.value &&
          parseInt(this.dataSource.stars.value.toString().replace(/[^\d]/g, ""))) ||
        0
      );
    },
    levelInfo() {
      if (this.starInfo >= 5) {
        return "Lv100";
      } else if (this.starInfo >= 4) {
        return "Lv80";
      } else {
        return "Lv60";
      }
    },
    roleUrl() {
      return (this.styleInfo && this.styleInfo.lh && this.styleInfo.lh.value) || "";
    }
  },
  data() {
    return {};
  },
  methods: {
    // Add any methods if needed
    handleReset() {
      this.$emit("reset");
    }
  }
};
</script>
<style lang="less" scoped>
.role-box {
  flex: 0 0 auto;
  width: 100%;
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 7px;
    .left {
      display: flex;
      align-items: center;
      .icon {
        width: 24px;
        height: 24px;
        margin-right: 7px;
      }
      .text {
        margin-right: 12px;
        color: #ffffff;
        font-size: 24px;
        font-weight: bold;
        &:last-child {
          margin-right: 0;
        }
      }
    }
    .right {
      display: flex;
      align-items: center;
      .btn {
        cursor: pointer;
        font-weight: bold;
        font-size: 14px;
        color: #473228;
        line-height: 28px;
        padding: 0 17px;
        border-radius: 20px;
        background-color: #e1dad5;
      }
    }
  }
  .star-box {
    display: flex;
    align-items: center;
    gap: 3px;
    width: 16px;
    height: 14px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .role-img-box {
    margin-top: 30px;
    width: 100%;
    height: 338px;
    overflow: hidden;

    .role-img {
      width: 100%;
      object-fit: cover;
      &.top-role {
        transform: translateY(-225px);
      }
    }
  }
}

.role-box.light {
  .header {
    .left {
      .text {
        color: #333333;
      }
    }
    .right {
      .btn {
        background: rgba(136, 183, 201, 0.2);
        border-radius: 21px;
        border: 1px solid #ffffff;
        color: #333333;
      }
    }
  }
}
</style>
